// frontend/src/components/mice/BulkActions.js
// Everything driven by the mice-table selection.
//
// Two exports rather than one, because they mount at different points in
// MiceManagement's tree: the bar sits inside the content column, the modal is
// an overlay at the root. Co-located here because they are one feature —
// both read `selectedCount`, both act on the same selection.
//
// All state and handlers live in MiceManagement; these are presentation.

import React from 'react';

export function BulkActionBar({
  selectedCount,
  isArchivedView,
  canTransfer,
  isExporting,
  unassignedResultsCount,
  onAddNewMouse,
  onEditSelected,
  onMoveSelected,
  onTransferSelected,
  onRestoreSelected,
  onArchiveSelected,
  onShowImport,
  onExportExcel,
  onOpenTransnetyx,
}) {
  const noSelection = selectedCount === 0;

  return (
    <div className="action-buttons">
      <button onClick={onAddNewMouse} className="primary-button fab">
        Add New Mouse
      </button>
      <button onClick={onEditSelected} className="primary-button fab" disabled={noSelection}>
        Edit ({selectedCount})
      </button>
      <button
        onClick={onMoveSelected}
        className="primary-button fab"
        style={{ backgroundColor: '#6f42c1', color: 'white' }}
        disabled={noSelection}
      >
        Move ({selectedCount})
      </button>
      {canTransfer && (
        <button
          onClick={onTransferSelected}
          className="primary-button fab"
          style={{ backgroundColor: '#17a2b8', color: 'white' }}
          disabled={noSelection}
        >
          Transfer ({selectedCount})
        </button>
      )}
      {isArchivedView ? (
        <button
          onClick={onRestoreSelected}
          className="primary-button fab"
          style={{ backgroundColor: '#28a745' }}
          disabled={noSelection}
        >
          Restore ({selectedCount})
        </button>
      ) : (
        <button
          onClick={onArchiveSelected}
          className="secondary-button fab"
          style={{ backgroundColor: '#dc3545' }}
          disabled={noSelection}
        >
          Archive ({selectedCount})
        </button>
      )}

      <button
        onClick={onShowImport}
        className="secondary-button fab"
        style={{ backgroundColor: '#28a745', color: 'white' }}
      >
        Import Excel
      </button>
      <button
        onClick={onExportExcel}
        className="secondary-button fab"
        style={{ backgroundColor: '#28a745', color: 'white', opacity: isExporting ? 0.6 : 1 }}
        disabled={isExporting}
      >
        {isExporting ? 'Exporting...' : 'Export Excel'}
      </button>
      <button
        onClick={onOpenTransnetyx}
        className="secondary-button fab"
        style={{
          // Teal for active, gray for inactive
          backgroundColor: unassignedResultsCount > 0 ? '#17a2b8' : '#6c757d',
          color: 'white',
          borderColor: unassignedResultsCount > 0 ? '#17a2b8' : '#6c757d',
        }}
      >
        {unassignedResultsCount > 0
          ? `Assign New Transnetyx Results (${unassignedResultsCount})`
          : 'No New Transnetyx Results'}
      </button>
    </div>
  );
}

export function TransferModal({
  selectedCount,
  labMembers,
  transferRecipientId,
  setTransferRecipientId,
  onConfirm,
  isTransferring,
  onCancel,
  error,
}) {
  return (
    <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', justifyContent: 'center', alignItems: 'center', zIndex: 1000 }}>
      <div style={{ backgroundColor: 'white', padding: '30px', borderRadius: '8px', maxWidth: '500px', width: '90%', maxHeight: '90%', overflowY: 'auto' }}>
        <h3>Transfer {selectedCount} Mice</h3>
        <p>Select a lab member to transfer the selected mice to. This will archive the mice for you and create new copies for the recipient.</p>

        <div className="form-group">
          <label>Transfer to:</label>
          <select
            value={transferRecipientId}
            onChange={(e) => setTransferRecipientId(e.target.value)}
            style={{ width: '100%', padding: '8px', boxSizing: 'border-box' }}
          >
            <option value="">Select lab member...</option>
            {labMembers.map((member) => (
              <option key={member.id} value={member.id}>
                {member.first_name && member.last_name
                  ? `${member.first_name} ${member.last_name} (${member.username})`
                  : member.username}
              </option>
            ))}
          </select>
        </div>

        {error && <div className="error">{error}</div>}

        <div style={{ display: 'flex', gap: '10px', marginTop: '20px' }}>
          <button onClick={onConfirm} style={{ flex: 1 }} className="primary-button" disabled={isTransferring}>
            {isTransferring ? 'Transferring...' : 'Confirm Transfer'}
          </button>
          <button onClick={onCancel} className="secondary-button" style={{ flex: 1 }}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
